import { render, staticRenderFns } from "./NButtonDelete.vue?vue&type=template&id=12f8b413&scoped=true&"
import script from "./NButtonDelete.vue?vue&type=script&lang=js&"
export * from "./NButtonDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8b413",
  null
  
)

export default component.exports